$(document).ready(function(){
  $('.menu-info a').click(function(event) {
    event.preventDefault();
    // Toggle active class on tab buttons
    $(this).parent().addClass("tb-current");
    $(this).parent().siblings().removeClass("tb-current");

    // display only active tab content
    var activeTab = $(this).attr("href");
    $('.tab-contents').not(activeTab).removeClass("activeTab");
    $(activeTab).addClass("activeTab");
  });
});